import Layout from "../components/Layout";

const SECTIONS = [
  ["Overview", "Insurance License Lab ('we', 'us') respects your privacy. This policy explains what we collect and how we use it. This is a general template and not legal advice."],
  ["Information We Collect", "Account details you provide (name, email), study activity (quiz results, audio progress), and payment records processed securely by our payment provider. We do not store full card numbers."],
  ["How We Use Information", "To operate your account, deliver your study content, track your progress, process payments, provide support, and improve the platform."],
  ["Your Personalized Copy", "Your workbook is personalized to your account so your materials and progress stay in sync across your devices whenever you sign in."],
  ["Data Sharing", "We do not sell your personal information. We share data only with service providers necessary to run the platform (e.g., payment processing) under appropriate safeguards."],
  ["Data Retention", "We retain account and progress data while your account is active. You may request deletion by contacting support."],
  ["Your Choices", "You can update your profile, request data export, or account deletion at any time through support."],
  ["Contact", "Questions about this policy? Reach us through the Support page."],
];

export default function Privacy() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="privacy-page">
        <h1 className="font-heading text-3xl font-bold text-[#0A192F]">Privacy Policy</h1>
        <p className="text-slate-400 text-sm mt-1">Last updated: {new Date().toLocaleDateString()}</p>
        <div className="mt-8 space-y-8">
          {SECTIONS.map(([h, b]) => (
            <section key={h}>
              <h2 className="font-heading text-lg font-semibold text-[#0A192F]">{h}</h2>
              <p className="text-slate-600 mt-2 leading-relaxed">{b}</p>
            </section>
          ))}
        </div>
      </div>
    </Layout>
  );
}
